// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__16JGP","ranges":"BmiRanges_ranges__3CcmJ"};